import React from 'react'
import { Form, Input, Button, message } from 'antd'

import recruitmentService from './../services/recruitments.service'

class Position extends React.Component {
  componentDidMount() {
    // To disable submit button at the beginning.
    this.props.form.validateFields()
  }

  handleSubmit = e => {
    e.preventDefault()
    this.props.form.validateFields(async (err, values) => {
      if (values.position === undefined) message.error('Position is empty!')
      else if (!err && values.position !== undefined) {
        this.validatePosition(values.position)
      }
    })
  }

  validatePosition = async position => {
    const positions = this.props.positions
    if (positions.some(pos => pos.name === position)) {
      message.error('Position already exists!')
    } else {
      const res = await recruitmentService.createPosition(position)
      if (res.rspCode === 'ok') {
        message.success('Position created!')
        this.props.handleCreatePosition()
      }
    }
  }

  render() {
    const { getFieldDecorator, getFieldsError } = this.props.form
    return (
      <Form
        style={{ marginBottom: '15px' }}
        layout="inline"
        onSubmit={this.handleSubmit}
      >
        <Form.Item>
          {getFieldDecorator('position')(
            <Input style={{ width: '383px' }} placeholder="Add Position" />
          )}
        </Form.Item>
        <Form.Item>
          <Button type="primary" htmlType="submit">
            Add
          </Button>
        </Form.Item>
      </Form>
    )
  }
}

const PositionForm = Form.create({})(Position)
export default PositionForm
